<template>
  <div class="row">
    <!-- <div class="col-md-12">
            <h1 class="h3 mb-3 text-gray-800">
                {{ $t("Prontuário Familiar") }}
            </h1>
        </div> -->
    <header-servico tipo="Benefício" :loading="loading" :familia="familia.id" />
    <load v-if="loading" message="Carregando o beneficio da Família" />
    <div v-else class="col-md-12">
      <!--Tabela-->
      <div class="row">
        <sidebar-servicos active="beneficios" />

        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div
                  class="animate__animated animate__fadeIn"
                  v-if="historicoStatus == false"
                >
                  <h4 class="h3 mb-3 text-gray-800">
                    {{ $t("Concessão de Benefício") }}
                  </h4>
                  <!--Bloco Responsável Familiar-->
                  <form @submit.prevent="submit">
                    <div class="row">
                    <form-select
                      v-model="beneficio.usuario_id"
                      label="Usuário(s)"
                      :itens="pessoas"
                      :required="true"
                      :disabled="true"
                    />
                    <form-select
                      v-model="beneficio.beneficio_id"
                      label="Benefício"
                      :itens="beneficios"
                      :required="true"
                      :grid="beneficio.quantidade ? '8' : '12'"
                      :disabled="true"
                      ajuda="Se o Benefício que você deseja liberar não for encontrado nas opções abaixo você deve cadastra  na página de gestão de benefícios ou solicitar o cadastro a quem tem permissões para realizar a ação"
                    />
                    <form-input
                      v-model="beneficio.valor"
                      label="Valor"
                      grid="5"
                      type="text"
                      inputGroup="true"
                      btnText="R$"
                      @input="formatarValor"
                      :disabled="true"
                      v-if="beneficio_categoria == 1"
                    />
                    <form-input
                      v-if="beneficio.beneficio.categoria == 2"
                      v-model="beneficio.quantidade"
                      label="Quantidade"
                      :min="this.beneficio.quantidade_entregue ? this.beneficio.quantidade_entregue : 1"
                      grid="4"
                      :disabled="isOwner == false"
                      :required="true"
                      type="number"
                    />
                    <form-select
                      v-model="beneficio.periodicidade"
                      label="Periodicidade"
                      grid="3"
                      :itens="$root.arrays.beneficio_periodicidade"
                    />
                    <form-select
                      v-model="beneficio.solicitante"
                      label="Solicitante"
                      grid="3"
                      :disabled="true"
                      :itens="$root.arrays.solicitante"
                      :required="true"
                    />
                    <form-input
                      v-model="beneficio.nome_solicitante"
                      label="Nome do Solicitante"
                      grid="6"
                      :disabled="true"
                      :readonly="true"
                    />
                    <form-textarea-editor
                      v-model="beneficio.observacoes"
                      grid="12"
                      label="Observação"
                      :disabled="(isGestor && isOwner == false) || isConcedido"
                    />
                    <form-textarea-editor
                      v-model="beneficio.parecer_tecnico"
                      grid="12"
                      label="Parecer Técnico"
                      :disabled="isOwner == false || isConcedido"
                    />
                    <form-select
                      v-model="beneficio.status_parecer"
                      label="Status do Parecer"
                      grid="6"
                      :itens="$root.arrays.status_parecer"
                      :required="true"
                      :disabled="
                        (isGestor && isOwner == false) ||
                        isConcedido ||
                        isFinalizado
                      "
                      @change="
                        beneficio.status_parecer == 4 ? atualizarStatus() : ''
                      "
                    />
                    <form-select
                      v-model="beneficio.status_liberacao"
                      label="Status da Concessão"
                      grid="6"
                      :itens="$root.arrays.status_liberacao"
                      :required="true"
                      :disabled="
                        isFinalizado
                          ? true
                          : !(isGestor || isTecnicoSuperior || isCoordenador)
                          ? true
                          : false
                      "
                      @change="
                        addNewStatusLiberacao();
                        atualizarStatus();
                      "
                    />
                    <form-file
                      @submit="submitFile"
                      multiple
                      label="Anexos (Recibos, fotos ou comprovante de entrega assinado)"
                      btn-text="Iniciar"
                      :progress="progressCompleted"
                      v-if="isGestor == false"
                    />
                  </div>
                  <div class="row pt-4 px-0 d-flex justify-content-end">
                    <div class="col-auto px-2 text-right">
                      <a
                        v-if="beneficio.entregas"
                        class="router-link-exact-active active px-3"
                        @click="
                          $bvModal.show('historico-entrega-beneficio');
                          beneficio = beneficio"
                      >
                        <i class="fas fa-history"></i>
                        Histórico de Entrega
                      </a>
                      <a
                        class="router-link-exact-active active px-3"
                        @click="historicoStatus = true"
                      >
                        <i class="fas fa-history"></i>
                        Histórico de Status
                      </a>
                      <a class="btn btn-default" @click="listBeneficios">
                        <i class="mdi mdi-arrow-left" />
                      </a>
                      <b-button
                        v-if="
                          getStatus(beneficio.status_liberacao) == 'CONCEDIDO' || getStatus(beneficio.status_liberacao) == 'ENTREGUE'
                        "
                        :title="$t('Visualizar e Imprimir')"
                        :to="
                          '/dashboard/familia/beneficio/show/' + beneficio.id
                        "
                        class="py-1"
                        size="sm"
                        type="button"
                        v-b-tooltip.hover
                        variant="primary"
                      >
                        <i class="mdi mdi-printer mdi-18px" />
                      </b-button>

                      <button
                        class="btn btn-secondary"
                        type="buttom"
                        v-if="
                          beneficio.status_liberacao == 2 &&
                          isOwner &&
                          !isGestor
                        "
                        @click.prevent="cancelarSolicitacao"
                      >
                        <i class="fas fa-ban"></i>
                        {{ $t("Cancelar Solicitação") }}
                      </button>
                      <button
                        class="btn btn-warning"
                        type="buttom"
                        v-if="
                          beneficio.entrega && beneficio.entrega.entregue == 0
                        "
                        @click.prevent="
                          beneficio = beneficio;
                          status_anterior = beneficio.status_liberacao;
                          $bvModal.show('entrega-beneficio');
                        "
                      >
                        <i class="fas fa-history"></i>
                        {{ $t("Registrar nova tentativa de entrega") }}
                      </button>

                      <a
                        class="btn btn-primary"
                        @click="$bvModal.show('modal-auditoria')"
                        :title="$t('Auditoria')"
                        v-b-tooltip.hover
                      >
                        <i class="mdi mdi-timeline-clock-outline mdi-16px" />
                      </a>

                      <a
                      v-if="
                          ($store.state.user.role_details.name == 'Admin' ||
                          $store.state.user.role_details.name == 'Gestor(a)' ||
                          (item && $store.state.user.id == item.user_id))
                      "
                        title="Remanejar"
                        class="btn btn-warning py-2"
                        @click="$bvModal.show('modal-remanejar-servico')"
                      >
                        <i class="fas fa-exchange-alt mdi-18px" />
                        {{ $t("Remanejar") }}
                      </a>

                      <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                        v-if="isOwner || isGestor"
                      >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                      </button>
                    </div>
                  </div>
                  <anexos v-if="beneficio.anexos" :anexos="beneficio.anexos" />
                  </form>
                </div>
                <div class="animate__animated animate__fadeIn" v-else>
                  <h4 class="h3 mb-3 text-gray-800">
                    {{ $t("Concessão de Benefício") }}
                  </h4>
                  <div class="row">
                    <HistoricoStatus
                      @voltar="historicoStatus = false"
                      :id="beneficio.id"
                      :familia="beneficio.familia_id"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalAtualizarStatus
      :beneficio="beneficio"
      @submit="submit()"
      :status-anterior="status_anterior"
    />
    <ModalEntrega
      :beneficio="beneficio"
      @submit="submit()"
      :status-anterior="status_anterior"
      :familiares="familiares"
    />
    <ModalHistoricoEntrega
      :beneficio="beneficio"
      :pessoas="pessoas"
    />
    <ModalRemanejarServico
      servico="beneficio"
      :servico_id="beneficio.id"
      :tecnico_id="beneficio.responsavel.tecnico.id"
    />
    <ModalAuditoria
      servico="familia/beneficio"
      :servico_id="beneficio.id"
    />
  </div>
</template>
<script>
import ModalRemanejarServico from "../../../../../resources/js/dashboard/components/widgets/ModalRemanejarServico";
import ModalAtualizarStatus from "./ModalAtualizarStatus";
import ModalEntrega from "./ModalEntregaGeral";
import HistoricoStatus from "./HistoricoStatus";
import ModalHistoricoEntrega from "./ModalHistoricoEntrega.vue";
import ModalAuditoria from '../../../../../resources/js/dashboard/components/widgets/ModalAuditoria';
export default {
  name: "Edit",
  components: { 
    ModalAtualizarStatus,
    HistoricoStatus, 
    ModalEntrega, 
    ModalHistoricoEntrega, 
    ModalRemanejarServico, 
    ModalAuditoria 
  },
  data() {
    return {
      beneficio: { responsavel: {tecnico: {}}, beneficio: { categoria: null } },
      beneficios: [],
      familia: [],
      pessoas: [],
      familiares: [],
      loading: true,
      historicoStatus: false,
      progressCompleted: 0,
      files: [],
      status_anterior: "",
      isGestor: false,
      isTecnicoSuperior: false,
      isCoordenador: false,
      isOwner: false,
      isChangeVisita: false,
      isConcedido: false,
      isFinalizado: false,
      nao_entregue: 0,
      showEntregas: false,
      beneficio_categoria: null,
    };
  },
  mounted() {
    this.getBeneficios();
    this.getBeneficio();
  },
  updated() {
    if (this.$store.state.user) {
      let role_user = this.$store.state.user.role_details.name;
      let user_id = this.$store.state.user.id;
      this.isGestor =
        this.$store.state.user.permissions["BeneficioController"] == true ||
        role_user == "Admin"
          ? true
          : false || this.$store.state.settings.autorizar_concessao == true;
      this.isOwner = user_id == this.beneficio.user_id ? true : false;
      if (role_user == "Técnico(a) de Nível Superior") {
        this.isTecnicoSuperior = true;
      } else if (role_user == "Coordenador") {
        this.isCoordenador = true;
      }
    }
  },
  watch: {
    isConcedido() {
      // if (this.isConcedido) {
      // 	// this.$root.arrays.status_liberacao.splice(0, 1);
      // 	// this.$root.arrays.status_liberacao.splice(1, 1);
      // 	this.$root.arrays.status_liberacao = [
      // 		{ id: 4, value: "CONCEDIDO" },
      // 		{ id: 6, value: "ENTREGUE" },
      // 		{ id: 7, value: "NÃO ENTREGUE" },
      // 	];
      // }
    },
  },

  methods: {
    formatarValor() {

			// Remove tudo o que não for número
			let valor = this.beneficio.valor.replace(/\D/g, '');

			// Adiciona o ponto de milhar e formata com a vírgula para centavos
			if (valor.length > 2) {
			valor = valor.replace(/(\d)(\d{2})$/, '$1,$2');
			}
			if (valor.length > 6) {
			valor = valor.replace(/(\d)(\d{3})(\d{3})$/, '$1.$2.$3');
			}

			// Atualiza o valor formatado no v-model
			this.beneficio.valor = valor;

		},
    carregarValorDoBanco(valor) {
      if(!valor) return null;
			// Verifica se o valor já tem separador decimal
			let formattedValue = valor.toString().trim();

			if (formattedValue.includes(',') || formattedValue.includes('.')) {

				// Se já tiver separador decimal, aplica a formatação de número com vírgula
				formattedValue = formattedValue.replace(/\D/g, '');
				
				if (formattedValue.length > 2) {

					formattedValue = formattedValue.replace(/(\d)(\d{2})$/, '$1,$2');

				}

				if (formattedValue.length > 6) {

					formattedValue = formattedValue.replace(/(\d)(\d{3})(\d{3})$/, '$1.$2.$3');

				}

			}else{

				// Caso não tenha separador de casas decimais, adicionamos ,00
				formattedValue = formattedValue.replace(/\D/g, '') + ',00';

			}

			return formattedValue;

		},
    // Função para limpar a formatação e enviar apenas o valor numérico
		formatarParaSubmit(valorFormatado) {

			// Remove todos os caracteres que não são números ou vírgula
			let valorLimpo = valorFormatado.replace(',', '.');

			return valorLimpo;

		},
    showHistoricoEntrega() {
      this.showEntregas = true;
      this.$bvModal.show("entrega-beneficio");
    },
    addNewStatusLiberacao() {
      let status_liberacao = this.getStatus(this.beneficio.status_liberacao);

      if (
        status_liberacao == "AGUARDANDO VISITA TÉCNICA" ||
        this.beneficio.status_parecer == 4
      ) {
        const result = this.$root.arrays.status_parecer.filter(
          (elem) => elem.id == 4
        );
        if (result.length == 0) {
          this.$root.arrays.status_parecer.push({
            id: 4,
            value: "VISITA TÉCNICA REALIZADA",
          });
        }
      }
    },

    getStatus(status) {
      const result = this.$root.arrays.status_liberacao.filter(
        (elem) => elem.id == status
      );
      return result[0] ? result[0].value : null;
    },
    atualizarStatus() {
      let status_liberacao = this.getStatus(this.beneficio.status_liberacao);
      if (status_liberacao == "ENTREGUE") {
        this.showEntregas = false;
        this.nao_entregue = 0;
        this.$bvModal.show("entrega-beneficio");
      } else if (status_liberacao == "NÃO ENTREGUE") {
        this.nao_entregue = 1;
        this.showEntregas = false;
        this.$bvModal.show("entrega-beneficio");
      } else {
        this.$bvModal.show("atualizar-status-beneficio");
      }
    },
    getBeneficios() {
      axios
        .get(`api/dashboard/get/beneficios`, {
          params: {
            edit: true,
          },
        })
        .then((response) => {
          this.beneficios = response.data;
        });
    },
    getBeneficio() {
      this.loading = true;
      var id = this.is_morph ? this.morphbeneficioId : this.$route.params.id;
      axios
        .get(`api/dashboard/familia/beneficio/${id}`)
        .then((response) => {
          this.beneficio_categoria = response.data.data.beneficio.categoria;
          this.beneficio = response.data.data;
          this.status_anterior = this.beneficio.status_liberacao;
          this.$route.query.familia_id = this.beneficio.familia_id;
          this.getFamilia(this.beneficio.familia_id);
          this.beneficio.status_liberacao == 4
            ? (this.isConcedido = true)
            : (this.isConcedido = false);
          this.beneficio.status_liberacao == 6
            ? (this.isFinalizado = true)
            : (this.isFinalizado = false);
          if (this.isConcedido && this.beneficio.status_liberacao == 4) {
            this.$root.arrays.status_liberacao = [
              { id: 4, value: "CONCEDIDO" },
              { id: 6, value: "ENTREGUE" },
              { id: 7, value: "NÃO ENTREGUE" },
            ];
          }

          if (this.beneficio.valor != null && this.beneficio.valor !== "") {

            // Carregar o valor formatado do banco
            this.beneficio.valor = this.carregarValorDoBanco(this.beneficio.valor);

          }
          
        })
        .finally(() => {
          this.loading = false;

          this.addNewStatusLiberacao();
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
    submitFile(files) {
      this.files = files;
    },
    submit() {
      let formData = new FormData();

      if (this.beneficio.valor != null && this.beneficio.valor !== "") {

        // Antes de enviar para o banco, formatamos o valor corretamente
        let valorParaEnviar = this.formatarParaSubmit(this.beneficio.valor);

        // Agora, atualizamos o valor no objeto 'beneficio'
        this.beneficio.valor = valorParaEnviar;

      }

      if (this.files.length > 0 && this.files.length != undefined) {
        for (const i of Object.keys(this.files)) {
          formData.append("files[]", this.files[i]);
        }
      } else {
        formData.append("files", this.files);
      }

      for (var key in this.beneficio) {
        formData.append(key, this.beneficio[key]);
      }

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      axios
        .post(`api/dashboard/familia/beneficio/concessao/update`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.getBeneficio();
          this.getBeneficios();
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
        });
    },
    getFamilia(id) {
      axios
        .get("api/dashboard/familias/" + id)
        .then((response) => {
          this.familia = response.data.data;
          this.$route.query.familia_id = this.familia.id;
          this.pessoas = this.familia.familiares.filter((elem) => {
            return elem.estado_cadastral_cadunico <= 3;
          });

          this.familiares = this.pessoas.map((elem) => {
            const nome = elem.nome_social
              ? elem.nome_social
              : `${elem.nome_completo}`;

            return {
              id: nome,
              value: nome,
            };
          });

          this.pessoas = this.pessoas.map((elem) => ({
            id: elem.id,
            value: elem.nome_social
              ? elem.nome_social
              : elem.nome_completo + " <b>" + elem.idade + " ano(s)</b>",
          }));
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
    listBeneficios() {
      let familia_id = this.familia.id;
      this.$router.push({
        path: `/dashboard/familia/beneficios/${familia_id}`,
      });
    },
    cancelarSolicitacao() {
      this.loading = true;
      axios
        .get(`api/dashboard/get/beneficios/cancelar/${this.beneficio.id}`)
        .then((response) => {
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.loading = false;
        })
        .finally(() => {
          this.listBeneficios();
        });
    },
  },
};
</script>
<style>
.router-link-exact-active {
  cursor: pointer;
}
</style>
